import { ValueTagEditorProps } from "./value-tag-editor.types";
import styles from "./value-tag-editor.module.scss";
import cl from "classnames";
import { AddOptionInput } from "./add-option-input";
import { ValueTag } from "../value-tag/value-tag";
import { useOverflowElementsMeta } from "./value-tag-editor.utils";
import { useState } from "react";

const ValueTagEditorComponent = (props: ValueTagEditorProps) => {
  const { className, style, editMode, valueTags, onInputValueAdded } = props;

  const hasValues = Boolean(valueTags?.length);

  const { valuesInnerContainer, overflowElementIndex, overflowElementsCount } =
    useOverflowElementsMeta(editMode);
  const valueTagsToDisplay = hasValues
    ? valueTags.slice(0, overflowElementIndex)
    : [];

  const [optionsHovered, setOptionsHovered] = useState(false);

  const onHover = (showOptions: boolean): void => {
    if (editMode && Boolean(editMode && overflowElementsCount)) {
      setTimeout(() => {
        setOptionsHovered(showOptions);
      }, 200);
    }
  };

  return (
    <div
      className={cl(styles.flexColumn)}
      style={style}
      onMouseEnter={() => onHover(true)}
      onMouseLeave={() => onHover(false)}
    >
      <div
        className={cl(
          styles.container,
          {
            [styles.valuesContainerEditMode]: editMode,
          },
          className
        )}
      >
        {hasValues && (
          <div className={styles.valuesContainer} ref={valuesInnerContainer}>
            {valueTagsToDisplay.map((valueTag, index) => {
              return (
                <ValueTag
                  key={index}
                  color={valueTag.color}
                  valueName={valueTag.valueName}
                  removable={editMode}
                  onRemove={() => valueTag.onRemove && valueTag.onRemove()}
                />
              );
            })}
          </div>
        )}

        {/* {Boolean(editMode && overflowElementsCount) && (
          <Text1 className={styles.overflowCount} onClick={() => onHover(true)}>
            +{overflowElementsCount}
          </Text1>
        )} */}

        {editMode && Boolean(onInputValueAdded) && (
          <AddOptionInput onInputValueAdded={onInputValueAdded} />
        )}
      </div>
      {optionsHovered && (
        <div
          className={styles.tagsCheckboxTags}
          onMouseEnter={() => onHover(true)}
          onMouseLeave={() => {
            if (editMode) {
              onHover(false);
            }
          }}
        >
          <div className={cl(styles.flexWrap)}>
            {valueTags.map((valueTag, index) => {
              return (
                <div className={styles.tagInHoverBox}>
                  <ValueTag
                    key={index}
                    color={valueTag.color}
                    valueName={valueTag.valueName}
                    removable={editMode}
                    onRemove={() => valueTag.onRemove && valueTag.onRemove()}
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

const ValueTagEditor = ValueTagEditorComponent;
export { ValueTagEditor };
